import React, { useState, useEffect } from 'react'
import './ProductoDetallePage.scss';
import Path from '../components/Path'
import { connect as connectRedux } from 'react-redux'
import { ProductImageSlider } from '../components/ProductImageSlider';
import { ProductoDetalleHeader } from '../components/ProductoDetalleHeader'
import { ProductoDetalleDescripcion } from '../components/ProductoDetalleDescripcion'
import { ProductoDetalleCaracteristicas } from '../components/ProductoDetalleCaracteristicas'
import ProductoDetalleComplementarios from '../components/ProductoDetalleComplementarios'
import ProductoDetalleExpositor from '../components/ProductoDetalleExpositor'
import ProductoDetalleTamano from '../components/ProductoDetalleTamano'
import  ProductoDetalleFormato from '../components/ProductoDetalleFormato'
import ProductoDetalleCantidad from '../components/ProductoDetalleCantidad'
import  ProductoDetalleTotal  from '../components/ProductoDetalleTotal'
import ProductoDetalleBtnCompra from '../components/ProductoDetalleBtnCompra'
import OtherProductsInterest from '../components/OtherProductsInterest'
import Separator from '../components/Separator';
import { getVariations } from '../hooks/getVariations'
import { useParams } from 'react-router-dom';
import { scrollBodyTop } from '../hooks/scrollPosition';
import { NotFoundIcon } from '../utils/icons'
import { privilegeUser } from '../hooks/user';
import {OptionsProductDesactivate} from '../components/OptionsProductDesactivate';
import { setProductsTable, setAllProducts } from '../actions';
import { getProducts, getProductsExpositors, getProductsImplantations, getProductsOutlet, getProductsPromoA, getProductsPromoB, getProductsPromoC } from '../hooks/gets';
import { productInOutlet } from '../hooks/productInOutlet'
import { BRANDCHOSEN, CambiarColoresPrincipales } from '../hooks/config';
import BrandChosenBanner from './BrandChosenBanner';
import _ from 'lodash';

const findProductById = (allProducts, id, ref) => {
    if (allProducts === undefined) {
        return undefined
    } else {
        for (let i = 0; i < allProducts.length; i++) {
            const el = allProducts[i];

            if (el.ID === id) {
                return el
            }
        }
    }
}

const setProductVariations = (productsAll, aux) => {
    const variations = getVariations(productsAll, aux)
    let variationSet = []
    for (let i = 0; i < variations.length; i++) {
        const variation = variations[i];
        if (variation.Diametro.toLowerCase().indexOf('set/') > -1) {
            variationSet.push(variation)
            variations.splice(i, 1)
        }
    }
    const variationsOrder = variations.sort(function (a, b) {
        return a.Diametro - b.Diametro
    })
    let variationsAll = []
    if (variationSet !== undefined) {
        variationsAll = variationsOrder.concat(variationSet)
    }
    return variationsAll
}

const getExpositor = (expositorsAll, producto) => {
    const expositors = []
    for (let i = 0; i < expositorsAll.length; i++) {
        const expositor = expositorsAll[i];
        const products = JSON.parse(expositor.ProductosExpositor)
        const expositorWithProduct = _.filter(products, { 'RefSuelto': producto.RefSuelto })
        if (expositorWithProduct.length > 0) {
            expositors.push(expositor)
        }
    }
    return expositors
}

const ProductoDetallePage = (props) => {
    console.log("productoDetallPage",props);
    const [producto, setProducto] = useState(null)
    const [variations, setVariations] = useState([])
    const [products, setProducts] = useState([])
    const [outlet, setOutlet] = useState([])
    const [expositors, setExpositors] = useState([])
    const [implantations, setImplantations] = useState([])
    const [promoA, setPromoA] = useState([])
    const [promoB, setPromoB] = useState([])
    const [promoC, setPromoC] = useState([])
    const [expositorContentProduct, setExpositorContentProduct] = useState([])
    const [privilege, setPrivilege] = useState(undefined)
    const { id } = useParams();

    useEffect(() => {
        scrollBodyTop()
        getPrivilege()
        loadProducts()
        CambiarColoresPrincipales()
    }, [])

    const loadProducts = async () => {
        let products = await getProducts()
        console.log("products",products);
        setProducts(products[BRANDCHOSEN])
        console.log("productsOutlet",await getProductsOutlet());
        setOutlet(await getProductsOutlet())
        setExpositors(await getProductsExpositors())
        try{
        setImplantations(await getProductsImplantations())
        }catch(e){
        }
        console.log("productsPromoA",await getProductsPromoA());
        setPromoA(await getProductsPromoA())
        setPromoB(await getProductsPromoB())
        setPromoC(await getProductsPromoC())
    }

    useEffect(() => {
        loadData()
    }, [id, products, outlet, expositors, promoA, promoB, promoC, implantations])

    const loadData = async () => {
        if (props.search === false) {
            getPrivilege()
            console.log("loaded id",id);
            let productAll = findProductById(products, id)
            let productOutlet = findProductById(outlet.data,id)
            let productExpositor = findProductById(expositors.data, id)
            let productImplantacion = findProductById(implantations.data,id)
            let productPromoA = findProductById(promoA.data,id)
            let productPromoB = findProductById(promoB.data,id)
            let productPromoC = findProductById(promoC.data, id)
            let product;
            if (productAll !== undefined) {
                props.setAllProducts(products)
                props.setProductsTable('allProducts')
                product = productAll
                setProductsVariable(product, expositors.data)
            } else if (productOutlet !== undefined) {
                props.setAllProducts(outlet.data)
                props.setProductsTable('allProductsOutlet')
                product = productOutlet
                setProductsVariable(product, expositors.data)
            } else if (productExpositor !== undefined) {
                props.setAllProducts(expositors.data)
                props.setProductsTable('allProductsExpositors')
                product = productExpositor
                setProductsVariable(product, expositors.data)
            } else if (productImplantacion !== undefined) {
                props.setAllProducts(implantations.data)
                props.setProductsTable('allProductsImplantations')
                product = productImplantacion
                setProductsVariable(product, expositors.data)
            } else if (productPromoA !== undefined) {
                props.setAllProducts(promoA.data)
                props.setProductsTable('allProductsPromoA')
                product = productPromoA
                setProductsVariable(product, promoA.data)
            } else if (productPromoB !== undefined) {
                props.setAllProducts(promoB.data)
                props.setProductsTable('allProductsPromoB')
                product = productPromoB
                setProductsVariable(product, promoB.data)
            } else if (productPromoC !== undefined) {
                props.setAllProducts(promoC.data)
                props.setProductsTable('allProductsPromoC')
                product = productPromoC
                setProductsVariable(product, promoC.data)
            }
            if (product !== undefined && product !== null) {
                const productOutlet = await productInOutlet(product)
                if (productOutlet !== undefined) {
                    product.Descuento = productOutlet.Descuento
                    product.PrecioTarifa = productOutlet.PrecioTarifa
                    setProducto(product)
                } else {
                    setProducto(product)
                }
            }
        }

    }

    const getPrivilege = async () => {
        setPrivilege(await privilegeUser())
    }

    const setProductsVariable = (product, expositorsAll) => {
        if (product !== undefined) {
            setProducto(product)
            if (props.allProducts.length > 0) {
                const variations = setProductVariations(props.allProducts, product)
                setVariations(variations)
            }
            if (expositorsAll !== undefined) {
                const expositors = getExpositor(expositorsAll, product)
                setExpositorContentProduct(expositors)
            }
        } else {
            setProducto(undefined)
        }
    }

    return (
        <div className="productos-detalle-page-container">
            {producto !== undefined && producto !== null &&
                <React.Fragment>
                    <div className="path">
                        <Path path="Inicio" />
                    </div>

                    <div className="brand-chosen-banner">
                      <BrandChosenBanner />
                    </div>

                    <div className="product">
                        <div className="img">
                            <ProductImageSlider product={producto}></ProductImageSlider>
                        </div>
                        <div className="title">
                            <ProductoDetalleHeader product={producto} nombre={producto.Nombre} descuento={producto.Descuento} productsTable={props.productsTable}></ProductoDetalleHeader>
                            <div className="separator">
                                <Separator />
                            </div>
                        </div>
                        <div className="details">
                            <div><ProductoDetalleDescripcion producto={producto}></ProductoDetalleDescripcion></div>
                            <div className="separator"><Separator /></div>
                            <div><ProductoDetalleCaracteristicas producto={producto} variaciones={variations} /></div>
                            {
                                producto.ProductoComplementario &&
                                <React.Fragment>
                                    <div className="separator"><Separator /></div>
                                    <div><ProductoDetalleComplementarios producto={producto}></ProductoDetalleComplementarios></div>
                                </React.Fragment>
                            }
                            {expositorContentProduct.length > 0 &&
                                <React.Fragment>
                                    <div className="separator"><Separator /></div>
                                    <div>
                                        <ProductoDetalleExpositor expositors={expositorContentProduct}></ProductoDetalleExpositor>
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                        <div className="options">
                            {
                                variations.length > 1 &&
                                <div><ProductoDetalleTamano producto={producto} variaciones={variations}></ProductoDetalleTamano></div>
                            }
                            {!_.isEmpty(props.userActive) ?
                                <React.Fragment>
                                    < div className="format"><ProductoDetalleFormato producto={producto}></ProductoDetalleFormato></div>
                                    <div><ProductoDetalleCantidad producto={producto} /></div>
                                    <div className="separator"><Separator /></div>
                                    <div className="total"><ProductoDetalleTotal producto={producto}></ProductoDetalleTotal></div>
                                    <div className="separator"><Separator /></div>
                                    <div className="boton-compra"><ProductoDetalleBtnCompra product={producto}></ProductoDetalleBtnCompra></div>
                                    <div className="precio">
                                        {privilege !== undefined && privilege &&
                                            <p>Precio de venta recomendado <strong>{producto.PrecioTarifa}€</strong></p>
                                        }
                                    </div>
                                </React.Fragment>
                                :
                                <OptionsProductDesactivate></OptionsProductDesactivate>
                            }
                        </div>
                    </div>
                </React.Fragment>
            }
            {
                producto === undefined &&
                <div className="sin-productos">
                    <div className="icon">
                        <NotFoundIcon size={70} />
                    </div>
                    <div className="text">
                        <p>Producto no encontrado</p>
                    </div>
                </div>
            }
            {producto !== undefined && producto !== null &&
                <OtherProductsInterest product={producto} />
            }
        </div >
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setProductsTable,
    setAllProducts
}

export default connectRedux(mapStateToProps, mapDispatchToProps)(ProductoDetallePage)